/*
 * The english translation of the toolbar
 */
export const TOOLBAR_EN = {
  textStyle: 'Text Style',
  normalText: 'Normal Text',
  heading2: 'Heading 2',
  heading3: 'Heading 3',
  undoTooltip: 'Undo',
  redoTooltip: 'Redo',
  linkTooltip: 'Insert Link',
  boldTooltip: 'Bold',
  italicTooltip: 'Italic',
  underlineTooltip: 'Underline',
  strikeTooltip: 'Strikethrough',
  bulletListTooltip: 'Bullet List',
  orderedListTooltip: 'Numbered List',
  highlightTooltip: 'Highlight',
  textStyleTooltip: 'Text Style',
  teilPromptingTooltip: 'Partial Prompting',
  clearTooltip: 'Clear Editor',
  copyTooltip: 'Copy Content'
}

/*
 * The german translation of the toolbar
 */
export const TOOLBAR_DE = {
  textStyle: 'Textstil',
  normalText: 'Normaler Text',
  heading2: 'Überschrift 2',
  heading3: 'Überschrift 3',
  undoTooltip: 'Rückgängig',
  redoTooltip: 'Wiederholen',
  linkTooltip: 'Link einfügen',
  boldTooltip: 'Fett',
  italicTooltip: 'Kursiv',
  underlineTooltip: 'Unterstrichen',
  strikeTooltip: 'Durchgestrichen',
  bulletListTooltip: 'Aufzählung',
  orderedListTooltip: 'Nummerierte Liste',
  highlightTooltip: 'Markieren',
  textStyleTooltip: 'Textstil',
  teilPromptingTooltip: 'Teil-Prompting',
  clearTooltip: 'Editor leeren',
  copyTooltip: 'Inhalt kopieren'
}
